if (!customElements.get('loyalty-points')) {
  customElements.define('loyalty-points', class LoyaltyPoints extends HTMLElement {
    constructor() {
      super();

      document.addEventListener("theme:cart:change", () => {
        this.updateLoyaltyPoints();
        console.log('Cart changed');
      });
    }

    // disconnectedCallback() {
    //   document.removeEventListener("theme:cart:change", () => {
    //     this.updateLoyaltyPoints();
    //   });
    // }

    connectedCallback() {
      console.log('Loyalty points connected');
      this.updateLoyaltyPoints();
    }

    async fetchCartData() {
      try {
        const res = await fetch("/cart.js");
        return await res.json();
      } catch (err) {
        console.error("Cart fetch error:", err);
        return null;
      }
    }

    async  fetchCustomerPoints(cart) {
      const container = document.querySelector(".loyalty-points__value-cart");
      if (!container || !cart?.items || cart.items.length === 0) return;
      let customerId = null;

      try {

        let discount = 0;
        cart.cart_level_discount_applications.forEach(
          ({total_allocated_amount}) =>{
            discount = discount + total_allocated_amount;
          }
        );

        discount = discount/100;
        // Create payload
        const draft_order_id = crypto.randomUUID();
        if (this.getAttribute('data-customer-id')) {
          customerId = this.getAttribute('data-customer-id');
        }
        const cartItems = cart.items.map((item) => ({
          sku: item.sku || item.variant_id || item.id,
          price: item.price/100,
          quantity: item.quantity,
          discount: item.line_level_total_discount/100 //item level discount
        }));

        const payload = { cartItems, customerId, draft_order_id, discount };

        // Call API

        
        let url = `https://azsu-rg-integration-qa-func-talon.azurewebsites.net/api/loyalty/points/cart?code=P2lX5NUxGMJK-pI4oX2MhDF9kVYZkv1dB4TxRSvwXqfJAzFuNKvuVQ==`;
        if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
          url = `https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-integration-prod-func-talonOne/loyalty/points/cart`;
        }
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        // Validate response
        if(response.status !== 200) throw new Error("Something is wrong.");

        try{
      // set here draft_order_id into attributes for reedem points
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
          attributes: {
            draft_order_id: draft_order_id,
            draft_key:customerId
            }
          })
        });
        }catch(err){}

        const responseJSON = await response.json();
        console.log(responseJSON);

        const points = responseJSON.totalPoints || 0;

        let string = this.dataset.headingText;
        if(points > 0) {
          container.innerHTML = string.replace("__points__", points);
        }
      } catch (error) {
        container.innerHTML = `You'll earn <strong>${0} Loyalty Points</strong> with your order.`;
      }
    }

    async updateLoyaltyPoints() {
      const cart = await this.fetchCartData();
      await this.fetchCustomerPoints(cart);
      console.log('Loyalty points updated');
    }
  });
}